<template>
  <div>
    <Header />

    <main class="app-content">
      <div class="app-title">
        <div>
          <h1><i class="fa fa-dashboard"></i>SAHA NOTLARI</h1>
        </div>
        <ul class="app-breadcrumb breadcrumb">
          <li class="breadcrumb-item"><i class="fa fa-home fa-lg"></i></li>
          <li class="breadcrumb-item"><a href="#"></a></li>
        </ul>
      </div>
      <form>
        <div class="form-group">
          <label class="control-label">Not Başlığı:</label>
          <input v-model="result.noticetitle" class="form-control" type="text"
            placeholder="Notun Görüntüleneceği Başlığı Belirtiniz" />
        </div>
        <div class="form-group">
          <label class="control-label">Not İçeriği:</label>
          <input v-model="result.noticecontent" class="form-control" type="text"
            placeholder="Not Hakkındaki Detayları Yazınız" />
        </div>
        <div>
          <button @click="sendData()" type="button" class="btn btn-success">YENİ NOT EKLE</button>
        </div>
      </form>
      <div class="row center">
        <div class="col-md-12 -webkit-scrollbar ">
          <div class="hr-title-home hr-long center">
            <abbr>
              <h2>NOTLAR</h2>
            </abbr>
          </div>
          <div style="height: 850px; overflow-y: overlay">
            <!-- class="tileHomepage"  yukarı dive eklenirse arka plan gelir-->
            <div class="col--12 sidenav">
              <div v-for="(item, index) in result" :key="index" class="col-md-12 col-lg-12 hower1"
                style="margin-bottom: 10px">

                <br />
                <a @click="routeDetailNotifications(item.id)" style="font-size: 14px " class="readmore">
                  <!-- @click="routeDetailNotifications(item.id)" yukarı a etiketinden sonra eklenirse tıklanabilir -->
                  <div class="block-blog text-left">
                    <div class="content-blog">
                      <a style="font-size: 14px" class="readmore" v-html="'<div>' + item.title + '</div>'"></a>
                      <a style="
                      overflow: hidden;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -webkit-box-orient: vertical;
                  " v-html="'<div>' + item.content + '</div>'"></a>
                      <a>{{ item.user_name }} -
                        {{ item.regdate }}</a>
                      <hr />
                    </div>
                  </div>

                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </main>

    <Sidebar />
  </div>
</template>

<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";

export default {
  data() {
    return {
      buttonid: "",
      result: [],
      result2: [],
      situation: false,
      img_base_url: store.state.img_base_url,
      saha_idm: this.$route.query.idm,
      saha_id2: this.$route.query.idm,
    };
  },
  methods: {
     sendData: function() {
        if (!this.result.noticetitle) {
        this.$swal({
          text: "Lütfen Not Başlığı Giriniz!",
          icon: "error",
          closeOnClickOutside: false,
        });
        return false;
      } else if (!this.result.noticecontent) {
        this.$swal({
          text: "Lütfen Not Açıklamasını Giriniz!!",
          icon: "error",
          closeOnClickOutside: false,
          

        });
        return false;
      }
      var url = store.state.base_url + "AslanSahalar/createSahaNote.php?key=123";

      var datas = {
        id: localStorage.getItem("id"),
        token: localStorage.getItem("token"),
       // sectionsId: localStorage.getItem("sectionsId"),
        gidertarihi: this.gidertarihi,
        title: this.result.noticetitle,
        user_id: this.user_id,
        content: this.result.noticecontent,
        saha_idm: this.saha_idm.substr(0,3),
      };
      axios
        .post(url, JSON.stringify(datas))
        .then((response) => {
          if (response.data.data == true) {
            this.$swal({
              text: "Not Başarıyla Eklendi!",
              icon: "success",
              closeOnClickOutside: true,
            });
            setTimeout(() => {
               location.reload();
            }, 1000);
           
          }
   
          ////conso.log(response);
        })
        .catch((error) => {
          //conso.log(error.response);
        });
    },
    routeAddNote: function () {
      this.$router.push("addNotice");
    },
    
    reload: function () {
      location.reload();
    },
    routeDetailNotices: function (itemId) {
      window.location.href = "#/noticesDetail?id=" + itemId;
    },
    routeDetailNotifications: function (itemId) {
      window.location.href = "#/notesDetailSaha?id=" + itemId;
    },
  },

  mounted: function () {
    let datas = [];
    this.buttonid = localStorage.getItem("id");
    let url = store.state.base_url + "AslanSahalar/getAllSahaNotes.php?key=123";
    var sendData = {
      id: localStorage.getItem("id"),
      token: localStorage.getItem("token"),
      saha_idm: this.saha_idm.substr(0,3),
    };

    axios
      .post(url, JSON.stringify(sendData))
      .then((response) => {
        this.result = response.data.data;
        console.log(this.result)
      })
      .catch((err) => {
        console.log(err.response);
      });
  },
  components: {
    Header,
    Sidebar,
  },
};
</script>
<style scoped>
.hower1:hover {
  background: #c1163b;

  color: white;
}

.hower2:hover {
  background: #1bbd0d;

  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/NotesSaha.vue